import {djangoFetch} from 'common/report/queries/utils';
import {ActivityMonitor} from 'common/util/activity-monitor';

export function getSessionHeartbeatMonitor(options = {}) {
  return new ActivityMonitor({
    cooldownMs: 5 * 60 * 1000, // once every 5 min should probably be enough
    onActive: async function emitHeartbeat() {
      const resp = await djangoFetch(`/security/hb`, {}, {priority: `low`});
      if (resp.redirected && resp.url.includes(`/login/`)) {
        // if the user is logged out, refresh so they get redirected to login w/ the next url as the current one
        location.reload();
      }
    },
    ...options,
  });
}

export const SessionHeartbeatSingleton = getSessionHeartbeatMonitor();
